import { createReducer } from '../../../../../utils/fsa';
import {
  failedSubscriptionForm,
  pendingSubscriptionForm,
  resetSubscriptionForm,
  successSubscriptionForm,
} from '../actions/index';
import {
  SendStatus,
} from '../component/subscription_form';

export interface ISubscriptionFormState {
  status: SendStatus;
  email?: string;
  // tslint:disable-next-line:no-any
  reqRes?: any;
  errorText?: string;
}

export default createReducer<ISubscriptionFormState>()
  .on(pendingSubscriptionForm, (state, action) => {
    return {
      status: action.payload.status,
      email: action.payload.email,
    };
  })
  .on(successSubscriptionForm, (state, action) => {
    return {
      status: action.payload.status,
      reqRes: action.payload.reqRes,
    };
  })
  .on(failedSubscriptionForm, (state, action) => {
    return {
      status: action.payload.status,
      errorText: action.payload.errorText,
    };
  })
  .on(resetSubscriptionForm, (state, action) => {
    return {
      status: SendStatus.INITIAL,
      email: '',
      reqRes: null,
      errorText: null,
    };
  })
  .build({
    status: SendStatus.INITIAL,
    email: '',
    reqRes: null,
    errorText: null,
  });



// WEBPACK FOOTER //
// ./src/bundles/common/components/subscription_form/reducer/index.ts